import { useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { IconButton } from '@ui/kit';
import { CogIcon } from '@ui/kit/icons';
import { SettingsLightbox } from '../../modals/settings-lightbox.js';
import { jsx } from 'react/jsx-runtime';

function SettingsAction(props) {
  const notifier = useNotifier();
  const handleClick = useCallback(() => {
    notifier.modal({
      theme: "dialog",
      content: /*#__PURE__*/jsx(SettingsLightbox, {
        course: props.course
      })
    });
    props.onSettingsOpened();
  }, [notifier, props]);
  return /*#__PURE__*/jsx(IconButton, {
    icon: /*#__PURE__*/jsx(CogIcon, {}),
    label: "Indstillinger",
    visibleLabel: true,
    onClick: handleClick
  });
}

export { SettingsAction };
//# sourceMappingURL=actions.settings.js.map
